import PageHero from "../components/PageHero";
import Marksheet from "../components/Marksheet";

export default function MarksheetPage() {
  return (
    <div data-testid="marksheet-page">
      <PageHero label="Examination" title="Marksheet" subtitle="Check whether your marksheet is available at the college office and whether it has been collected." />
      <Marksheet />
    </div>
  );
}
